import { render, staticRenderFns } from "./VitaProtezione.vue?vue&type=template&id=ec60a836&"
import script from "./VitaProtezione.vue?vue&type=script&lang=ts&"
export * from "./VitaProtezione.vue?vue&type=script&lang=ts&"
import style0 from "./VitaProtezione.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports